import React from "react";

const BreadCrumb = ({ crumbs, flyoutFunction, setAnimation, navData, tabIndex }: any) => {

  // get node by keyword
  const getNodeByID = (node: any, keyword: string) =>{
    return node.find((o:any) => o.id === keyword);
  }

  // click listener for back arrow
  const changeBackContent = (event:any, name:any) => {
    // catch link
    event.preventDefault();

    // get selected nav level
    const deepLevel = crumbs.findIndex((e: any) => e === name);

    // get root level by id
    let nodeDetail = getNodeByID(navData, crumbs[0].id);

    // get X level from root based on deep level
    for(
      let crumbsPointer = 1;
      crumbsPointer <= deepLevel; crumbsPointer += 1) { nodeDetail = getNodeByID(nodeDetail.children, crumbs[crumbsPointer].id);
    }

    // set new crumbs range
    crumbs.splice(deepLevel + 1);

    // return list
    flyoutFunction(nodeDetail);

    // animation direction
    const lastDeepLevelValue = deepLevel + 1;

    if (lastDeepLevelValue < 1) {
      setAnimation('animate__fadeInRight');
    } else {
      if (lastDeepLevelValue > deepLevel ) {
        setAnimation('animate__fadeInLeft');
      } else {
        setAnimation('animate__fadeInRight');
      }
    }
  }

  // check for html soft hyphen and set them to unicode
  const getItemLabel = (textRef:string) => {
    let newText = textRef;
    if(textRef !== undefined){
      newText = textRef.replaceAll('&shy;', '\u00AD');
    }
    return newText;
  };
  return (
    <>
      {crumbs && crumbs.map((crumb: any, index: number) =>
        (
          <div
            key={index}
            className="breadcrumb__item js-breadcrumb-item"
            data-id={crumb.id}
          >
              <span className={"breadcrumb__text"} style={{maxWidth:(97/crumbs.length)+"%"}}>
                {getItemLabel(crumb.headline)}
              </span>
          </div>
        ))
      }
    </>
  )
}

export default BreadCrumb;
